/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { groupBy } from 'lodash';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from '../../../../SharedModules/PaginationBox/PaginationBox';
import ExportIcon from '../../../../assets/images/Icon-Component-Export.svg';
import { leftHead, rightHead } from './TableHead';
import {
  getDisplayScreenLeftGrid,
  getDisplayScreenRightGrid,
  exportAllPDF,
  exportAllExcel,
  exportAllLEFTExcel,
  clearExportData
} from '../Store/actions';
import { exportAllData } from './ExportAll';
import {exportAllDataExcel1} from './ExportAllLeftExcel';
import {exportAllDataExcel} from './ExportAllRightExcel';

import CommonModal from '../../../../SharedModules/Dialog/CommonModal';

const QuarterlyClaimReconcilliationDetail = () => {
  const dispatch = useDispatch();

  const {
    isLoading,
    leftGridData,
    rightGridData,
    rightGridDataForAll,
    leftGridDataForAll,
    headerGridData,
    selectedRequest,
    qtr,
  } = useSelector(
    (state) => state?.sharedState?.QuarterlyClaimsReconcilliationReducer
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );

  const [filteredRows, setFilteredRow] = React.useState([]);
  const [leftTableRows, setLeftTableRows] = React.useState([]);
  const [rightTableRows, setRightTableRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [allowDowbload, setAllowDownload] = React.useState(false);
  const [dlgTxt, setDlgTxt] = React.useState('');
  const [dlgErr, setDlgErr] = React.useState(false);
  const [openDlg, setOpenDlg] = React.useState(false);
  const [exportType, setExportType] = useState(null); 
    const [fileName, setfileName] = React.useState('');


  // Function to toggle fullscreen view of table
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // Function to struct data as perl left grid data table
  const formatLeftTableData = (rawData) => {
    const groupData = groupBy(rawData, 'subtitle');
    const data = [];

    let sumRecordCount = 0;
    for (const key in groupData) {
      data.push({
        recordCount: ' ',
        title: key,
        head: true,
      });
      for (let j = 0; j < groupData[key].length; j++) {
        data.push({
          recordCount: groupData[key][j].recordCount,
          title: groupData[key][j].descr,
        });
        sumRecordCount += groupData[key][j].recordCount;
      }
    }
    data.push({
      recordCount: sumRecordCount,
      title: 'Total:',
      head: true,
    });
    return data;
  };
  // Set the left table data rows
  React.useEffect(() => {
    let data = formatLeftTableData(leftGridData);
    data = data.map((item) => {
      return {
        ...item,
        recordCount: item.recordCount.toLocaleString('en-US'),
      };
    });
    setLeftTableRows(data);
  }, [leftGridData]);
  // Set the table data rows
  React.useEffect(() => {
    setRightTableRows(rightGridData);
  }, [rightGridData]);  
React.useEffect(() => {
  if (
    headerGridData?.length &&
    Object.keys(leftGridDataForAll)?.length === headerGridData.length &&
    Object.keys(rightGridDataForAll)?.length === headerGridData.length &&
    allowDowbload &&
    exportType
  ) {
    setAllowDownload(false);

    const leftGridFormattedData = {};
    for (const i in leftGridDataForAll) {
      leftGridFormattedData[i] = formatLeftTableData(leftGridDataForAll[i]);
    }

    const payload = {
      leftGridData: leftGridFormattedData,
      rightGridData: rightGridDataForAll,
    };

    if (exportType === 'pdf') {
      exportAllData(
        payload,
        userDefaults,
        selectedRequest,
        logInUser,
        dlgTxt
      );
    } 
    else if (exportType === 'excelSummary') {
      exportAllDataExcel(
        payload,
        userDefaults,
        selectedRequest,
        logInUser,
        fileName
      );
    } 
    else if (exportType === 'excelDetail') {
      exportAllDataExcel1(
        payload,
        userDefaults,
        selectedRequest,
        logInUser,
        fileName
      );
    }

    setDlgTxt('');
    setExportType(null);
  }
}, [
  leftGridDataForAll,
  rightGridDataForAll,
  headerGridData,
  allowDowbload,
  exportType,
]);


  /*
    This function handle the side effect of next previios of pagination box
  */
  const handleClick = (type, value) => {
    if (type === 'next') {
      setCount(count + 1);
    }

    if (type === 'previous') {
      setCount(count - 1);
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        setCount(paginationArray.length);
      } else {
        setCount(value);
      }
    }
  };

  const [count, setCount] = React.useState(1);
  // const [paginationArray, setPaginationArray] = React.useState([
  //   ...Array(headerGridData.length).keys(),
  // ]);
  const [paginationArray, setPaginationArray] = React.useState([]);

  React.useEffect(() => {
    if (headerGridData && headerGridData.length > 0) {
      setPaginationArray([...Array(headerGridData.length).keys()]);
    } else {
      setPaginationArray([]);
    }
  }, [headerGridData]);

  /*
       this function handle the vlue like text in input box
    */
  const handleBlur = async (value) => {
    if (
      value < 1 ||
      parseInt(value) > paginationArray.length ||
      value === '' ||
      isNaN(value)
    ) {
      setCount(0);
      await Promise.resolve();
      // setTimeout(() => {
        value < 1 ? setCount(1) : setCount(paginationArray.length);
      // }, 20);
    } else {
      setCount(parseInt(value));
    }
  };

  React.useEffect(() => {
    if (headerGridData?.length > 0) {
      const input = {
        ...selectedRequest,
        quarter: selectedRequest.qtr,
        rebateProgramCd: headerGridData[count - 1]?.rebateProgramCd,
      };
      dispatch(getDisplayScreenRightGrid(input));
      dispatch(getDisplayScreenLeftGrid(input));
    }
  }, [headerGridData, selectedRequest, count]);
  React.useEffect(() => {
    dispatch(clearExportData());
  }, []);
  const exportAll = () => {
    if (headerGridData?.length > 0) {
      setAllowDownload(true);
      const input = {
        ...selectedRequest,
        quarter: selectedRequest.qtr,
      };
      const values = {
        input,
        allRebates: headerGridData,
      };
      dispatch(exportAllPDF(values));
      // dispatch(getDisplayScreenRightGrid(input));
      // dispatch(getDisplayScreenLeftGrid(input));
    }
  };
 const exportAllE = (dlgTxt) => {
    setExportType('excelDetail');
    setfileName(dlgTxt);

    if (headerGridData?.length > 0) {
      setAllowDownload(true);
      const input = {
        ...selectedRequest,
        quarter: selectedRequest.qtr,
      };
      const values = {
        input,
        allRebates: headerGridData,
      };
      dispatch(exportAllExcel(values));
 
    }
  };
const exportAllLEFTE = (dlgTxt) => {
    setExportType('excelSummary');
    setfileName(dlgTxt);
    if (headerGridData?.length > 0) {
      setAllowDownload(true);
      const input = {
        ...selectedRequest,
        quarter: selectedRequest.qtr,
      };
      const values = {
        input,
        allRebates: headerGridData,
      };
      dispatch(exportAllLEFTExcel(values));
 
    }
  };


  
  
  const sum = (property) => {
    const displayedRows =
      filteredRows.length > 0 ? filteredRows : rightTableRows;
    if (property === 'checkLogNum') {
    } else {
      const data = displayedRows?.reduce((accumulator, object) => {
        return (
          accumulator + (object[property] ? parseFloat(object[property]) : null)
        );
      }, 0);
      return data ? data.toLocaleString('en-US') : '0';
    }
  };
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i++) {
      result.push({
        isBottomRow: true,
        head: true,
        recordCount: sum('recordCount'),
        claimLoadDt: 'Total:',
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [rightTableRows, filteredRows]);

  const onFilterChangedRight = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
        recordCount: parseFloat(
          item.recordCount.replace('$', '').replace(/,/g, '')
        ),
      };
    });
    setFilteredRow(updatedRowData);
  };

  // Below 2 variable for PDF header slected information
    const firstInfo = `Rebate Program Cd: ${
    headerGridData?.[count - 1]?.rebateProgramCd
  } - ${headerGridData?.[count - 1]?.shortDescr || 'No data available'}`;
  const fourthInfo = `Quarter: ${selectedRequest.qtr}`;
  const leftTableRowsFilter = leftTableRows.filter(item => !item.head);
  return (
    <div className='tabs-container'>
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1='State Reports'
        parent2='Quarterly Claims Reconciliation Details'
      />

      <div className='tab-body'>
        {!fullScreenView && (
          <>
            <div className='row mb-5'>
              <div className='col-12'>
                <div className='float-right'>
                  <PaginationBox
                    array={paginationArray}
                    count={count}
                    handleClick={handleClick}
                    handleBlur={handleBlur}
                  />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12  '>
                <div className='form-wrapper p-0 mt-2'>
                  <div className='mui-custom-form input-md field-xl'>
                    <div className='row mb-2'>
                      <div className='col-6'>
                        <TextField
                          label='Rebate Program: '
                          id='rebateProgram'
                          inputProps={{ id: 'rebateProgram' }}
                          fullWidth
                          placeholder=''
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={`${
                            headerGridData?.[count - 1]?.rebateProgramCd || ''
                          } - ${headerGridData?.[count - 1]?.shortDescr || ''}`}
                        />
                      </div>
                      <div className='col-6'>
                        <TextField
                          label='Submitted By: '
                          id='submitby'
                          inputProps={{ id: 'submitby' }}
                          fullWidth
                          placeholder=''
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={selectedRequest?.requestorUserId || ''}
                        />
                      </div>
                      <div className='col-6'>
                        <TextField
                          label='Quarter: '
                          id='qtr'
                          inputProps={{ id: 'qtr' }}
                          fullWidth
                          placeholder=''
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={selectedRequest?.qtr || ''}
                        />
                      </div>
                    </div>
                    <div className='float-right'>
                      <div className='col-6'>
                        <>
                          <Dropdown className='icon-dropdown-container'>
                            <Dropdown.Toggle
                              className='icon-dropdown'
                              aria-label='Actions Button'
                            >
                              <OverlayTrigger
                                placement='bottom'
                                overlay={
                                  <Tooltip id='action-tooltip'>Actions</Tooltip>
                                }
                              >
                                <img
                                  alt='Export Button'
                                  style={{ marginRight: -55, width: 32 }}
                                  src={ExportIcon}
                                />
                              </OverlayTrigger>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                data-testid='export-all'
                                onClick={() => setOpenDlg(true)}
                              >
                                Export to PDF
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                          <CommonModal
                            open={openDlg}
                            className='dialog-420'
                            viewAction
                            viewHeader
                            onOk={() => {
                              setOpenDlg(false);
                              setExportType('pdf');
                              exportAll();
                            }}
                            okTitle='Ok'
                            disableOk={!dlgTxt || dlgErr}
                            onClose={() => {
                              setOpenDlg(false);
                              //setDlgTxt('');
                            }}
                            closeTitle='Cancel'
                            modalTitle='Save Data In File'
                            autoFocus
                            childrenComponent={
                              <div className='form-wrapper'>
                                <div className='mui-custom-form'>
                                  <TextField
                                    className='mb-3'
                                    id='filename'
                                    inputProps={{ id: 'filename' }}
                                    label='File Name'
                                    required
                                    autoFocus
                                    InputLabelProps={{ shrink: true }}
                                    data-testid='filename-input'
                                    value={dlgTxt}
                                    onChange={(e) => {
                                      setDlgTxt(e.target.value);
                                      if (
                                        e.target.value &&
                                        !/^[\w\-. ]+$/.test(e.target.value)
                                      )
                                        setDlgErr(true);
                                      else setDlgErr(false);
                                    }}
                                    error={dlgErr}
                                    helperText={
                                      dlgErr
                                        ? 'Invalid character in file name'
                                        : ''
                                    }
                                  />
                                </div>
                              </div>
                            }
                          />
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className='row' style={{ marginTop: 15 }}>
          <div className='unallocated col-6 hidefil' style={{ width: '100vw' }}>
            <TableGridWithFeatures
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              columnDefs={leftHead}
              headerHeight={0}
              rowData={leftTableRows}
              data-testid='onEditingStopped'
              enterMovesDown
              showResetFilter={false}
              noGlobalSort
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              exportAllDataExcel1={exportAllDataExcel1}
              hideTotalCount={true}
              exportFile
              exportAllE={exportAllE}
              exportAllToXlsx1
              fileName='QuarterlyClaimsRecon'
              reportName='Quarterly Claims Reconciliation Report'
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ firstInfo,  fourthInfo }}
              skipColumnHeaders
              skipHeaderRow
            />
              <p className="total-results" tabIndex="0">
              Total Results: <b>{leftTableRowsFilter?.length?.toLocaleString('en-US')}</b>
              </p>
          </div>
          <div className='unallocated col-6' style={{ width: '100vw' }}>
            <TableGridWithFeatures
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              columnDefs={rightHead}
              exportAllToXlsx2
              exportAllLEFTE={exportAllLEFTE}
              exportAllDataExcel={exportAllDataExcel}
              rowData={rightTableRows.map((item) => {
                return {
                  ...item,
                  recordCount: item.recordCount?.toLocaleString('en-US'),
                };
              })}
              onFilterData={onFilterChangedRight}
              data-testid='onEditingStopped1'
              enterMovesDown
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              hideTotalCount={false}
              exportFile
              fileName='QuarterlyClaimsRecon'
              reportName='Quarterly Claims Reconciliation Report'
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ firstInfo,  fourthInfo }}
              pinnedBottomRowData={pinnedBottomRowData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuarterlyClaimReconcilliationDetail;
